// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.budgetContainer {
    .budgetElement {
        width: 70%;
        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);
        border-radius: 5px;
        padding:20px 50px;
        background-color: white;

        label{
            font-size: 16px;
            font-weight: 500;
        }

        .elements {
            margin: 15px 0px;
        }


        textarea,
        select,
        input {
            width: 100%;
            border: 1px solid #D5D5D5;
            padding: 5px 10px;
            font-size: 16px;
            font-weight: 400;
            border-radius: 3px;
        }


        textarea {
            height: 12vh;
        }

        ::placeholder {
            color: #817f7f;
        }
    }
}




table tbody tr td {
    border-right: 1px solid white !important;
    border-bottom:1px solid white !important;
    text-align: center;
}
 
table th{
      border-right: 1px solid #d4ddef !important;
    border-bottom: 1px solid #d4ddef !important;
    text-align: center;
}
 


.budget-gr-datepicker {
  width: 100%;
}

.budget-gr-datepicker .react-datepicker-wrapper {
  width: 100%;
}

.budget-gr-datepicker .react-datepicker__input-container input {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  border: 1px solid #c7c0c0;
  padding: 7px 10px;
  font-size: 12px;
  box-sizing: border-box;
}


/* =========================================
   BUDGET HEAD CREATION - PROFESSIONAL THEME
========================================= */

.budget-head-page {
  background: #ffffff !important;
  color: #24364b;
}

/* Page heading */
.budget-head-page h5 {
  color: #173b65 !important;
  font-size: 22px !important;
  font-weight: 700 !important;
  letter-spacing: 0.2px;
}

.budget-head-page .fa-user {
  color: #1769aa !important;
  background: #e2efff;
  padding: 10px;
  border-radius: 10px;
}

/* Form wrapper */
.budget-head-page form {
  max-width: 1200px !important;
}

/* Main form section */
.budget-head-page form > div:first-child {
  background: #eef1f6 !important;
  border: 1px solid #d8e5f4 !important;
  border-radius: 14px !important;
  padding: 28px !important;
  box-shadow: 0 4px 18px rgba(35, 74, 120, 0.07) !important;
}

/* Two-column form grid */
.budget-head-page form > div:first-child > div:first-child {
  column-gap: 24px !important;
  row-gap: 20px !important;
}

/* Labels */
.budget-head-page .form-label {
  color: #263f5c !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  margin-bottom: 7px !important;
font-size: 14px !important;
    font-weight: 700 !important;
    color: #1f2430;
    line-height: 20px;
}

/* Text inputs and file inputs */
.budget-head-page input.form-control {
  width: 100%;
  min-height: 42px;
  background-color: #ffffff;
  color: #24364b;
  border: 1px solid #cbd8e8 !important;
  border-radius: 8px !important;
  padding: 9px 12px !important;
  font-family: Inter, sans-serif;
  font-size: 13px !important;
  box-shadow: none !important;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
}

/* Focus state */
.budget-head-page input.form-control:focus {
  border-color: #3984d6 !important;
  box-shadow: 0 0 0 3px rgba(57, 132, 214, 0.12) !important;
  outline: none;
}

/* React Select dropdown */
.budget-head-page .css-b62m3t-container,
.budget-head-page [class*="-container"] {
  width: 100%;
  font-size: 13px;
}

.budget-head-page [class*="-control"] {
  min-height: 42px !important;
  border-radius: 8px !important;
  border-color: #cbd8e8 !important;
  box-shadow: none;
  background: #ffffff;
}

.budget-head-page [class*="-control"]:hover {
  border-color: #3984d6 !important;
}

.budget-head-page [class*="-menu"] {
  z-index: 100;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(20, 50, 90, 0.13);
}

.budget-head-page [class*="-option"] {
  font-size: 13px;
  padding: 10px 12px;
}

/* Add / Update button */
.budget-head-page form button:first-child {
  transition: background-color 0.2s, transform 0.2s;
}

.budget-head-page form button[style*="background-color: rgb(0, 102, 204)"] {
  background-color: #1769aa !important;
  border-radius: 8px !important;
  box-shadow: 0 3px 8px rgba(23, 105, 170, 0.18) !important;
}

.budget-head-page form button[style*="backgroundColor: #0066cc"],
.budget-head-page form button {
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

/* Form action buttons */
.budget-head-page form button:hover {
  filter: brightness(0.95);
}

/* Added heads table container */
.budget-head-page > div:last-child {
  max-width: 1200px;
}

/* Table */
.budget-head-page table {
  width: 100%;
  border-collapse: separate !important;
  border-spacing: 0;
  border: 1px solid #dce6f2;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  font-size: 12px !important;
}

/* Table header */
.budget-head-page table thead tr {
  background: #e8f1ff !important;
  color: #203c60 !important;
}

.budget-head-page table thead th {
  background: #e8f1ff !important;
  color: #203c60 !important;
  padding: 13px 14px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  border-bottom: 1px solid #d3e1f3 !important;
  border-right: 1px solid #dce6f2 !important;
  white-space: nowrap;
}

/* Table body */
.budget-head-page table tbody td {
  padding: 12px 14px !important;
  color: #34475e;
  border-bottom: 1px solid #e7edf5;
  border-right: 1px solid #edf1f7;
  vertical-align: middle;
  text-align: center;
  line-height: 1.5;
}

/* Alternate rows */
.budget-head-page table tbody tr:nth-child(even) {
  background: #f8faff;
}

.budget-head-page table tbody tr:nth-child(odd) {
  background: #ffffff;
}

/* Table hover */
.budget-head-page table tbody tr:hover {
  background: #eff6ff;
}

/* Remove final row border */
.budget-head-page table tbody tr:last-child td {
  border-bottom: none;
}

/* Edit and Delete buttons */
.budget-head-page table tbody button {
  min-height: 32px;
  padding: 6px 10px !important;
  border-radius: 6px !important;
  font-size: 11px !important;
  transition: background-color 0.2s;
}

.budget-head-page table tbody button img {
  width: 15px !important;
  height: 15px !important;
}

/* Final Submit button */
.budget-head-page button:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}

/* Validation messages */
.budget-head-page span[style*="#dc3545"] {
  color: #dc3545 !important;
  font-size: 11px !important;
  margin-top: 5px;
}

/* Responsive layout */
@media (max-width: 768px) {
  .budget-head-page {
    padding: 14px !important;
  }

  .budget-head-page form > div:first-child {
    padding: 18px !important;
  }

  .budget-head-page form > div:first-child > div:first-child {
    grid-template-columns: 1fr !important;
    row-gap: 16px !important;
  }

  .budget-head-page > div:last-child {
    overflow-x: auto;
  }

  .budget-head-page table {
    min-width: 700px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .budget-head-page {
    padding: 20px !important;
  }

  .budget-head-page form > div:first-child {
    padding: 22px !important;
  }
}



/* ==========================================
   BUDGET HEAD TABLE - PROFESSIONAL UI
========================================== */

/* Table wrapper */
.budget-head-page .budget-table-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 24px auto 0;
  background: #ffffff;
  border: 1px solid #d8e5f4;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(35, 74, 120, 0.06);
  overflow: hidden;
}

/* Table scroll container */
.budget-head-page .budget-table-scroll {
  width: 100%;
  overflow-x: auto;
}

/* Main table */
.budget-head-page .budget-head-table {
  width: 100%;
  min-width: 850px;
  margin: 0;
  border-collapse: separate !important;
  border-spacing: 0;
  table-layout: auto;
  background: #ffffff;
  font-family: Inter, sans-serif;
  font-size: 12px;
}

/* Header */
.budget-head-page .budget-head-table thead th {
  background: #e8f1ff !important;
  color: #1d3b60 !important;
  padding: 15px 12px !important;
  text-align: center;
  vertical-align: middle;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1.5;
  white-space: nowrap;
  border: none !important;
  border-bottom: 2px solid #cbdcf3 !important;
  border-right: 1px solid #dce6f2 !important;
}

/* Rounded header corners */
.budget-head-page .budget-head-table thead th:first-child {
  border-top-left-radius: 11px;
}

.budget-head-page .budget-head-table thead th:last-child {
  border-top-right-radius: 11px;
  border-right: none !important;
}

/* Body cells */
.budget-head-page .budget-head-table tbody td {
  padding: 13px 12px !important;
  color: #35465c;
  text-align: center;
  vertical-align: middle;
  font-size: 12px !important;
  line-height: 1.5;
  border: none !important;
  border-bottom: 1px solid #e5ecf5 !important;
  border-right: 1px solid #edf1f7 !important;
  overflow-wrap: anywhere;
}

/* Alternating row colors */
.budget-head-page .budget-head-table tbody tr:nth-child(odd) {
  background: #ffffff;
}

.budget-head-page .budget-head-table tbody tr:nth-child(even) {
  background: #f7faff;
}

/* Row hover */
.budget-head-page .budget-head-table tbody tr:hover {
  background: #edf5ff !important;
  transition: background-color 0.2s ease;
}

/* Last row */
.budget-head-page .budget-head-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Last column */
.budget-head-page .budget-head-table th:last-child,
.budget-head-page .budget-head-table td:last-child {
  border-right: none !important;
}

/* Action column */
.budget-head-page .budget-head-table th:last-child,
.budget-head-page .budget-head-table td:last-child {
  min-width: 150px;
  white-space: nowrap;
}

/* Action buttons layout */
.budget-head-page .budget-table-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Common action button */
.budget-head-page .budget-table-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 32px;
  padding: 6px 11px !important;
  border-radius: 6px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Edit button */
.budget-head-page .budget-table-actions .budget-edit-btn {
  color: #1769aa !important;
  background: #eef6ff !important;
  border: 1px solid #9dc5f2 !important;
}

.budget-head-page .budget-table-actions .budget-edit-btn:hover {
  background: #dcecff !important;
  border-color: #1769aa !important;
}

/* Delete button */
.budget-head-page .budget-table-actions .budget-delete-btn {
  color: #d9363e !important;
  background: #fff1f0 !important;
  border: 1px solid #f2b8b8 !important;
}

.budget-head-page .budget-table-actions .budget-delete-btn:hover {
  background: #ffe0de !important;
  border-color: #d9363e !important;
}

/* Empty table message */
.budget-head-page .budget-head-table tbody td[colspan] {
  padding: 28px 16px !important;
  text-align: center;
  color: #718198;
  font-size: 13px !important;
}

/* Final submit section */
.budget-head-page .budget-table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #ffffff;
  border-top: 1px solid #e3ebf5;
}

/* Final submit button */
.budget-head-page .budget-final-submit {
  min-height: 38px;
  padding: 9px 22px !important;
  color: #ffffff !important;
  background: #218838 !important;
  border: 1px solid #218838 !important;
  border-radius: 7px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.budget-head-page .budget-final-submit:hover {
  background: #19692c !important;
}

/* Responsive */
@media (max-width: 768px) {
  .budget-head-page .budget-table-wrapper {
    margin-top: 18px;
    border-radius: 8px;
  }

  .budget-head-page .budget-head-table {
    min-width: 850px;
  }

  .budget-head-page .budget-head-table thead th {
    padding: 12px 10px !important;
  }

  .budget-head-page .budget-head-table tbody td {
    padding: 10px !important;
  }

  .budget-head-page .budget-table-footer {
    padding: 12px;
  }
}



/* ===== Budget Head Table - Blue Dashboard Theme ===== */

.budget-head-page .budget-table-wrapper {
  width: 100%;
  margin-top: 24px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e1eaf5;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(35, 74, 120, 0.10);
  box-sizing: border-box;
}

.budget-head-page .budget-table-scroll {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #a9cdf5;
  border-radius: 6px;
}

.budget-head-page .budget-head-table {
  width: 100%;
  min-width: 800px;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
  background: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
}

/* Blue header */
.budget-head-page .budget-head-table thead th {
  background: #2f7bd9 !important;
  color: #ffffff !important;
  padding: 12px 10px;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  border: none !important;
  border-right: 1px solid rgba(255, 255, 255, 0.4) !important;
  border-bottom: 1px solid #a9cdf5 !important;
}

.budget-head-page .budget-head-table thead th:last-child {
  border-right: none !important;
}

/* Alternating light-blue rows */
.budget-head-page .budget-head-table tbody tr:nth-child(odd) {
  background: #e6f3fc;
}

.budget-head-page .budget-head-table tbody tr:nth-child(even) {
  background: #cfe4f2;
}

/* Row hover */
.budget-head-page .budget-head-table tbody tr:hover {
  background: #b9daf5;
}

.budget-head-page .budget-head-table tbody td {
  padding: 11px 10px;
  text-align: center;
  vertical-align: middle;
  color: #222222;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  border: none !important;
  border-right: 1px solid #b7d6f4 !important;
  border-bottom: 1px solid #b7d6f4 !important;
  overflow-wrap: anywhere;
}

.budget-head-page .budget-head-table tbody td:last-child {
  border-right: none !important;
}

.budget-head-page .budget-head-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Column widths */
.budget-head-page .budget-head-table th:nth-child(1) {
  width: 7%;
}

.budget-head-page .budget-head-table th:nth-child(2) {
  width: 21%;
}

.budget-head-page .budget-head-table th:nth-child(3) {
  width: 13%;
}

.budget-head-page .budget-head-table th:nth-child(4) {
  width: 27%;
}

.budget-head-page .budget-head-table th:nth-child(5) {
  width: 12%;
}

.budget-head-page .budget-head-table th:nth-child(6) {
  width: 20%;
}

/* Edit and Delete buttons */
.budget-head-page .budget-table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.budget-head-page .budget-edit-btn,
.budget-head-page .budget-delete-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 4px;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.budget-head-page .budget-edit-btn {
  color: #2f7bd9;
  background: #eef5fd;
  border: 1px solid #2f7bd9;
}

.budget-head-page .budget-edit-btn:hover {
  background: #d9eaff;
}

.budget-head-page .budget-delete-btn {
  color: #dc3545;
  background: #fff0f0;
  border: 1px solid #dc3545;
}

.budget-head-page .budget-delete-btn:hover {
  background: #ffe0e0;
}

.budget-head-page .budget-edit-btn img,
.budget-head-page .budget-delete-btn img {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

/* Final Submit button */
.budget-head-page .budget-table-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
}

.budget-head-page .budget-final-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 145px;
  height: 36px;
  padding: 0 18px;
  color: #ffffff;
  background: #2f7bd9;
  border: 1px solid #2f7bd9;
  border-radius: 5px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(47, 123, 217, 0.20);
}

.budget-head-page .budget-final-submit:hover {
  background: #2167bd;
  border-color: #2167bd;
}

.budget-head-page .budget-final-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* Responsive layout */
@media (max-width: 768px) {
  .budget-head-page .budget-table-wrapper {
    padding: 10px;
    margin-top: 18px;
  }

  .budget-head-page .budget-head-table {
    min-width: 800px;
  }

  .budget-head-page .budget-table-footer {
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/BudgetManagement/BudgetHeadCreation/BudgetHead.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;QACV,gDAAgD;QAChD,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;;QAEvB;YACI,eAAe;YACf,gBAAgB;QACpB;;QAEA;YACI,gBAAgB;QACpB;;;QAGA;;;YAGI,WAAW;YACX,yBAAyB;YACzB,iBAAiB;YACjB,eAAe;YACf,gBAAgB;YAChB,kBAAkB;QACtB;;;QAGA;YACI,YAAY;QAChB;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ;;;;;AAKA;IACI,wCAAwC;IACxC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;MACM,0CAA0C;IAC5C,2CAA2C;IAC3C,kBAAkB;AACtB;;;;AAIA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;;AAGA;;2CAE2C;;AAE3C;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,yDAAyD;AAC3D;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;AAC/B,0BAA0B;IACtB,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;AACrB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,yDAAyD;EACzD,aAAa;AACf;;AAEA,0BAA0B;AAC1B;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qCAAqC;IACrC,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;;;AAIA;;4CAE4C;;AAE5C,kBAAkB;AAClB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,2CAA2C;EAC3C,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;;EAEE,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;;;AAIA,yDAAyD;;AAEzD;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;EAC3D,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".budgetContainer {\r\n    .budgetElement {\r\n        width: 70%;\r\n        box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.274);\r\n        border-radius: 5px;\r\n        padding:20px 50px;\r\n        background-color: white;\r\n\r\n        label{\r\n            font-size: 16px;\r\n            font-weight: 500;\r\n        }\r\n\r\n        .elements {\r\n            margin: 15px 0px;\r\n        }\r\n\r\n\r\n        textarea,\r\n        select,\r\n        input {\r\n            width: 100%;\r\n            border: 1px solid #D5D5D5;\r\n            padding: 5px 10px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n            border-radius: 3px;\r\n        }\r\n\r\n\r\n        textarea {\r\n            height: 12vh;\r\n        }\r\n\r\n        ::placeholder {\r\n            color: #817f7f;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\ntable tbody tr td {\r\n    border-right: 1px solid white !important;\r\n    border-bottom:1px solid white !important;\r\n    text-align: center;\r\n}\r\n \r\ntable th{\r\n      border-right: 1px solid #d4ddef !important;\r\n    border-bottom: 1px solid #d4ddef !important;\r\n    text-align: center;\r\n}\r\n \r\n\r\n\r\n.budget-gr-datepicker {\r\n  width: 100%;\r\n}\r\n\r\n.budget-gr-datepicker .react-datepicker-wrapper {\r\n  width: 100%;\r\n}\r\n\r\n.budget-gr-datepicker .react-datepicker__input-container input {\r\n  width: 100%;\r\n  height: 42px;\r\n  border-radius: 10px;\r\n  border: 1px solid #c7c0c0;\r\n  padding: 7px 10px;\r\n  font-size: 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n/* =========================================\r\n   BUDGET HEAD CREATION - PROFESSIONAL THEME\r\n========================================= */\r\n\r\n.budget-head-page {\r\n  background: #ffffff !important;\r\n  color: #24364b;\r\n}\r\n\r\n/* Page heading */\r\n.budget-head-page h5 {\r\n  color: #173b65 !important;\r\n  font-size: 22px !important;\r\n  font-weight: 700 !important;\r\n  letter-spacing: 0.2px;\r\n}\r\n\r\n.budget-head-page .fa-user {\r\n  color: #1769aa !important;\r\n  background: #e2efff;\r\n  padding: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* Form wrapper */\r\n.budget-head-page form {\r\n  max-width: 1200px !important;\r\n}\r\n\r\n/* Main form section */\r\n.budget-head-page form > div:first-child {\r\n  background: #eef1f6 !important;\r\n  border: 1px solid #d8e5f4 !important;\r\n  border-radius: 14px !important;\r\n  padding: 28px !important;\r\n  box-shadow: 0 4px 18px rgba(35, 74, 120, 0.07) !important;\r\n}\r\n\r\n/* Two-column form grid */\r\n.budget-head-page form > div:first-child > div:first-child {\r\n  column-gap: 24px !important;\r\n  row-gap: 20px !important;\r\n}\r\n\r\n/* Labels */\r\n.budget-head-page .form-label {\r\n  color: #263f5c !important;\r\n  font-size: 13px !important;\r\n  font-weight: 600 !important;\r\n  margin-bottom: 7px !important;\r\nfont-size: 14px !important;\r\n    font-weight: 700 !important;\r\n    color: #1f2430;\r\n    line-height: 20px;\r\n}\r\n\r\n/* Text inputs and file inputs */\r\n.budget-head-page input.form-control {\r\n  width: 100%;\r\n  min-height: 42px;\r\n  background-color: #ffffff;\r\n  color: #24364b;\r\n  border: 1px solid #cbd8e8 !important;\r\n  border-radius: 8px !important;\r\n  padding: 9px 12px !important;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 13px !important;\r\n  box-shadow: none !important;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Focus state */\r\n.budget-head-page input.form-control:focus {\r\n  border-color: #3984d6 !important;\r\n  box-shadow: 0 0 0 3px rgba(57, 132, 214, 0.12) !important;\r\n  outline: none;\r\n}\r\n\r\n/* React Select dropdown */\r\n.budget-head-page .css-b62m3t-container,\r\n.budget-head-page [class*=\"-container\"] {\r\n  width: 100%;\r\n  font-size: 13px;\r\n}\r\n\r\n.budget-head-page [class*=\"-control\"] {\r\n  min-height: 42px !important;\r\n  border-radius: 8px !important;\r\n  border-color: #cbd8e8 !important;\r\n  box-shadow: none;\r\n  background: #ffffff;\r\n}\r\n\r\n.budget-head-page [class*=\"-control\"]:hover {\r\n  border-color: #3984d6 !important;\r\n}\r\n\r\n.budget-head-page [class*=\"-menu\"] {\r\n  z-index: 100;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 24px rgba(20, 50, 90, 0.13);\r\n}\r\n\r\n.budget-head-page [class*=\"-option\"] {\r\n  font-size: 13px;\r\n  padding: 10px 12px;\r\n}\r\n\r\n/* Add / Update button */\r\n.budget-head-page form button:first-child {\r\n  transition: background-color 0.2s, transform 0.2s;\r\n}\r\n\r\n.budget-head-page form button[style*=\"background-color: rgb(0, 102, 204)\"] {\r\n  background-color: #1769aa !important;\r\n  border-radius: 8px !important;\r\n  box-shadow: 0 3px 8px rgba(23, 105, 170, 0.18) !important;\r\n}\r\n\r\n.budget-head-page form button[style*=\"backgroundColor: #0066cc\"],\r\n.budget-head-page form button {\r\n  border-radius: 8px !important;\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n/* Form action buttons */\r\n.budget-head-page form button:hover {\r\n  filter: brightness(0.95);\r\n}\r\n\r\n/* Added heads table container */\r\n.budget-head-page > div:last-child {\r\n  max-width: 1200px;\r\n}\r\n\r\n/* Table */\r\n.budget-head-page table {\r\n  width: 100%;\r\n  border-collapse: separate !important;\r\n  border-spacing: 0;\r\n  border: 1px solid #dce6f2;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #ffffff;\r\n  font-size: 12px !important;\r\n}\r\n\r\n/* Table header */\r\n.budget-head-page table thead tr {\r\n  background: #e8f1ff !important;\r\n  color: #203c60 !important;\r\n}\r\n\r\n.budget-head-page table thead th {\r\n  background: #e8f1ff !important;\r\n  color: #203c60 !important;\r\n  padding: 13px 14px !important;\r\n  font-size: 12px !important;\r\n  font-weight: 700 !important;\r\n  border-bottom: 1px solid #d3e1f3 !important;\r\n  border-right: 1px solid #dce6f2 !important;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Table body */\r\n.budget-head-page table tbody td {\r\n  padding: 12px 14px !important;\r\n  color: #34475e;\r\n  border-bottom: 1px solid #e7edf5;\r\n  border-right: 1px solid #edf1f7;\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Alternate rows */\r\n.budget-head-page table tbody tr:nth-child(even) {\r\n  background: #f8faff;\r\n}\r\n\r\n.budget-head-page table tbody tr:nth-child(odd) {\r\n  background: #ffffff;\r\n}\r\n\r\n/* Table hover */\r\n.budget-head-page table tbody tr:hover {\r\n  background: #eff6ff;\r\n}\r\n\r\n/* Remove final row border */\r\n.budget-head-page table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Edit and Delete buttons */\r\n.budget-head-page table tbody button {\r\n  min-height: 32px;\r\n  padding: 6px 10px !important;\r\n  border-radius: 6px !important;\r\n  font-size: 11px !important;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.budget-head-page table tbody button img {\r\n  width: 15px !important;\r\n  height: 15px !important;\r\n}\r\n\r\n/* Final Submit button */\r\n.budget-head-page button:disabled {\r\n  opacity: 0.75;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Validation messages */\r\n.budget-head-page span[style*=\"#dc3545\"] {\r\n  color: #dc3545 !important;\r\n  font-size: 11px !important;\r\n  margin-top: 5px;\r\n}\r\n\r\n/* Responsive layout */\r\n@media (max-width: 768px) {\r\n  .budget-head-page {\r\n    padding: 14px !important;\r\n  }\r\n\r\n  .budget-head-page form > div:first-child {\r\n    padding: 18px !important;\r\n  }\r\n\r\n  .budget-head-page form > div:first-child > div:first-child {\r\n    grid-template-columns: 1fr !important;\r\n    row-gap: 16px !important;\r\n  }\r\n\r\n  .budget-head-page > div:last-child {\r\n    overflow-x: auto;\r\n  }\r\n\r\n  .budget-head-page table {\r\n    min-width: 700px;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .budget-head-page {\r\n    padding: 20px !important;\r\n  }\r\n\r\n  .budget-head-page form > div:first-child {\r\n    padding: 22px !important;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* ==========================================\r\n   BUDGET HEAD TABLE - PROFESSIONAL UI\r\n========================================== */\r\n\r\n/* Table wrapper */\r\n.budget-head-page .budget-table-wrapper {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  margin: 24px auto 0;\r\n  background: #ffffff;\r\n  border: 1px solid #d8e5f4;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 16px rgba(35, 74, 120, 0.06);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Table scroll container */\r\n.budget-head-page .budget-table-scroll {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n/* Main table */\r\n.budget-head-page .budget-head-table {\r\n  width: 100%;\r\n  min-width: 850px;\r\n  margin: 0;\r\n  border-collapse: separate !important;\r\n  border-spacing: 0;\r\n  table-layout: auto;\r\n  background: #ffffff;\r\n  font-family: Inter, sans-serif;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Header */\r\n.budget-head-page .budget-head-table thead th {\r\n  background: #e8f1ff !important;\r\n  color: #1d3b60 !important;\r\n  padding: 15px 12px !important;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-size: 12px !important;\r\n  font-weight: 700 !important;\r\n  line-height: 1.5;\r\n  white-space: nowrap;\r\n  border: none !important;\r\n  border-bottom: 2px solid #cbdcf3 !important;\r\n  border-right: 1px solid #dce6f2 !important;\r\n}\r\n\r\n/* Rounded header corners */\r\n.budget-head-page .budget-head-table thead th:first-child {\r\n  border-top-left-radius: 11px;\r\n}\r\n\r\n.budget-head-page .budget-head-table thead th:last-child {\r\n  border-top-right-radius: 11px;\r\n  border-right: none !important;\r\n}\r\n\r\n/* Body cells */\r\n.budget-head-page .budget-head-table tbody td {\r\n  padding: 13px 12px !important;\r\n  color: #35465c;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-size: 12px !important;\r\n  line-height: 1.5;\r\n  border: none !important;\r\n  border-bottom: 1px solid #e5ecf5 !important;\r\n  border-right: 1px solid #edf1f7 !important;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n/* Alternating row colors */\r\n.budget-head-page .budget-head-table tbody tr:nth-child(odd) {\r\n  background: #ffffff;\r\n}\r\n\r\n.budget-head-page .budget-head-table tbody tr:nth-child(even) {\r\n  background: #f7faff;\r\n}\r\n\r\n/* Row hover */\r\n.budget-head-page .budget-head-table tbody tr:hover {\r\n  background: #edf5ff !important;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n/* Last row */\r\n.budget-head-page .budget-head-table tbody tr:last-child td {\r\n  border-bottom: none !important;\r\n}\r\n\r\n/* Last column */\r\n.budget-head-page .budget-head-table th:last-child,\r\n.budget-head-page .budget-head-table td:last-child {\r\n  border-right: none !important;\r\n}\r\n\r\n/* Action column */\r\n.budget-head-page .budget-head-table th:last-child,\r\n.budget-head-page .budget-head-table td:last-child {\r\n  min-width: 150px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Action buttons layout */\r\n.budget-head-page .budget-table-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n/* Common action button */\r\n.budget-head-page .budget-table-actions button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  min-height: 32px;\r\n  padding: 6px 11px !important;\r\n  border-radius: 6px !important;\r\n  font-size: 11px !important;\r\n  font-weight: 600 !important;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* Edit button */\r\n.budget-head-page .budget-table-actions .budget-edit-btn {\r\n  color: #1769aa !important;\r\n  background: #eef6ff !important;\r\n  border: 1px solid #9dc5f2 !important;\r\n}\r\n\r\n.budget-head-page .budget-table-actions .budget-edit-btn:hover {\r\n  background: #dcecff !important;\r\n  border-color: #1769aa !important;\r\n}\r\n\r\n/* Delete button */\r\n.budget-head-page .budget-table-actions .budget-delete-btn {\r\n  color: #d9363e !important;\r\n  background: #fff1f0 !important;\r\n  border: 1px solid #f2b8b8 !important;\r\n}\r\n\r\n.budget-head-page .budget-table-actions .budget-delete-btn:hover {\r\n  background: #ffe0de !important;\r\n  border-color: #d9363e !important;\r\n}\r\n\r\n/* Empty table message */\r\n.budget-head-page .budget-head-table tbody td[colspan] {\r\n  padding: 28px 16px !important;\r\n  text-align: center;\r\n  color: #718198;\r\n  font-size: 13px !important;\r\n}\r\n\r\n/* Final submit section */\r\n.budget-head-page .budget-table-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 16px 20px;\r\n  background: #ffffff;\r\n  border-top: 1px solid #e3ebf5;\r\n}\r\n\r\n/* Final submit button */\r\n.budget-head-page .budget-final-submit {\r\n  min-height: 38px;\r\n  padding: 9px 22px !important;\r\n  color: #ffffff !important;\r\n  background: #218838 !important;\r\n  border: 1px solid #218838 !important;\r\n  border-radius: 7px !important;\r\n  font-size: 12px !important;\r\n  font-weight: 600 !important;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.budget-head-page .budget-final-submit:hover {\r\n  background: #19692c !important;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .budget-head-page .budget-table-wrapper {\r\n    margin-top: 18px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .budget-head-page .budget-head-table {\r\n    min-width: 850px;\r\n  }\r\n\r\n  .budget-head-page .budget-head-table thead th {\r\n    padding: 12px 10px !important;\r\n  }\r\n\r\n  .budget-head-page .budget-head-table tbody td {\r\n    padding: 10px !important;\r\n  }\r\n\r\n  .budget-head-page .budget-table-footer {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n\r\n\r\n/* ===== Budget Head Table - Blue Dashboard Theme ===== */\r\n\r\n.budget-head-page .budget-table-wrapper {\r\n  width: 100%;\r\n  margin-top: 24px;\r\n  padding: 16px 18px;\r\n  background: #ffffff;\r\n  border: 1px solid #e1eaf5;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 8px rgba(35, 74, 120, 0.10);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.budget-head-page .budget-table-scroll {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  border: 1px solid #a9cdf5;\r\n  border-radius: 6px;\r\n}\r\n\r\n.budget-head-page .budget-head-table {\r\n  width: 100%;\r\n  min-width: 800px;\r\n  margin: 0;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  table-layout: auto;\r\n  background: #ffffff;\r\n  font-family: \"Inter\", sans-serif;\r\n  font-size: 12px;\r\n}\r\n\r\n/* Blue header */\r\n.budget-head-page .budget-head-table thead th {\r\n  background: #2f7bd9 !important;\r\n  color: #ffffff !important;\r\n  padding: 12px 10px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n  white-space: nowrap;\r\n  border: none !important;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.4) !important;\r\n  border-bottom: 1px solid #a9cdf5 !important;\r\n}\r\n\r\n.budget-head-page .budget-head-table thead th:last-child {\r\n  border-right: none !important;\r\n}\r\n\r\n/* Alternating light-blue rows */\r\n.budget-head-page .budget-head-table tbody tr:nth-child(odd) {\r\n  background: #e6f3fc;\r\n}\r\n\r\n.budget-head-page .budget-head-table tbody tr:nth-child(even) {\r\n  background: #cfe4f2;\r\n}\r\n\r\n/* Row hover */\r\n.budget-head-page .budget-head-table tbody tr:hover {\r\n  background: #b9daf5;\r\n}\r\n\r\n.budget-head-page .budget-head-table tbody td {\r\n  padding: 11px 10px;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  color: #222222;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n  border: none !important;\r\n  border-right: 1px solid #b7d6f4 !important;\r\n  border-bottom: 1px solid #b7d6f4 !important;\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.budget-head-page .budget-head-table tbody td:last-child {\r\n  border-right: none !important;\r\n}\r\n\r\n.budget-head-page .budget-head-table tbody tr:last-child td {\r\n  border-bottom: none !important;\r\n}\r\n\r\n/* Column widths */\r\n.budget-head-page .budget-head-table th:nth-child(1) {\r\n  width: 7%;\r\n}\r\n\r\n.budget-head-page .budget-head-table th:nth-child(2) {\r\n  width: 21%;\r\n}\r\n\r\n.budget-head-page .budget-head-table th:nth-child(3) {\r\n  width: 13%;\r\n}\r\n\r\n.budget-head-page .budget-head-table th:nth-child(4) {\r\n  width: 27%;\r\n}\r\n\r\n.budget-head-page .budget-head-table th:nth-child(5) {\r\n  width: 12%;\r\n}\r\n\r\n.budget-head-page .budget-head-table th:nth-child(6) {\r\n  width: 20%;\r\n}\r\n\r\n/* Edit and Delete buttons */\r\n.budget-head-page .budget-table-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.budget-head-page .budget-edit-btn,\r\n.budget-head-page .budget-delete-btn {\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n  min-height: 28px;\r\n  padding: 0 10px;\r\n  border-radius: 4px;\r\n  font-family: \"Inter\", sans-serif;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.budget-head-page .budget-edit-btn {\r\n  color: #2f7bd9;\r\n  background: #eef5fd;\r\n  border: 1px solid #2f7bd9;\r\n}\r\n\r\n.budget-head-page .budget-edit-btn:hover {\r\n  background: #d9eaff;\r\n}\r\n\r\n.budget-head-page .budget-delete-btn {\r\n  color: #dc3545;\r\n  background: #fff0f0;\r\n  border: 1px solid #dc3545;\r\n}\r\n\r\n.budget-head-page .budget-delete-btn:hover {\r\n  background: #ffe0e0;\r\n}\r\n\r\n.budget-head-page .budget-edit-btn img,\r\n.budget-head-page .budget-delete-btn img {\r\n  width: 14px;\r\n  height: 14px;\r\n  object-fit: contain;\r\n}\r\n\r\n/* Final Submit button */\r\n.budget-head-page .budget-table-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  margin-top: 16px;\r\n}\r\n\r\n.budget-head-page .budget-final-submit {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  min-width: 145px;\r\n  height: 36px;\r\n  padding: 0 18px;\r\n  color: #ffffff;\r\n  background: #2f7bd9;\r\n  border: 1px solid #2f7bd9;\r\n  border-radius: 5px;\r\n  font-family: \"Inter\", sans-serif;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 5px rgba(47, 123, 217, 0.20);\r\n}\r\n\r\n.budget-head-page .budget-final-submit:hover {\r\n  background: #2167bd;\r\n  border-color: #2167bd;\r\n}\r\n\r\n.budget-head-page .budget-final-submit:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive layout */\r\n@media (max-width: 768px) {\r\n  .budget-head-page .budget-table-wrapper {\r\n    padding: 10px;\r\n    margin-top: 18px;\r\n  }\r\n\r\n  .budget-head-page .budget-head-table {\r\n    min-width: 800px;\r\n  }\r\n\r\n  .budget-head-page .budget-table-footer {\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
